var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoGameController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.59,115.16H81.88M66.43,99v32.3m35.11-10.53h16.85s8.42,31.59,37.91,28.08c0,0,35.11-1.4,32.3-38.61,0,0-4.21-29.49-33.7-29.49h-92S27.11,80.06,32,122.88c0,0,4.21,28.79,38.62,26C70.65,148.86,92.41,147.46,101.54,120.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.69,106a5.62,5.62,0,1,1-5.62-5.61,5.62,5.62,0,0,1,5.62,5.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.24,123.59a5.62,5.62,0,1,1-5.61-5.62,5.61,5.61,0,0,1,5.61,5.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGameController);
export default __webpack_public_path__ + "static/media/VIDEO_GAME_CONTROLLER.173ab47e08c4060b6715cd3af2c7cf04.svg";
export { ForwardRef as ReactComponent };